// Tabs the SRM can turn off per AM (Manage Users → Tabs). Keys match AM_TABS
// in backend/server.py, which also blocks the API behind a hidden tab.
export const AM_TABS = [
    { key: "add", label: "What to add", group: "What to add" },
    { key: "prices", label: "Price changes", group: "What to add" },
    { key: "new", label: "New on boutiqaat", group: "What to add" },
    { key: "top", label: "Top selling on boutiqaat", group: "What to add" },
    { key: "favorites", label: "Favorites (starred SKUs + brands, highlighted when new / enabled / received)", path: "/favorites" },
    { key: "exclusives", label: "Exclusive Items + Exclusive picks", path: "/inventory/exclusive" },
    { key: "stock", label: "Stock alarm", path: "/inventory/stock-alarm" },
    { key: "photos", label: "Photo → SKUs", path: "/photo-skus" },
    { key: "gaps", label: "Look-alike gaps", path: "/lookalike-gaps" },
    { key: "scorecard", label: "Weekly scorecard", path: "/am-scorecard" },
    { key: "sort", label: "Boutique Sort (sort their own celebrities' boutiques)", path: "/boutique-sort" },
    { key: "sortperf", label: "Sort performance", path: "/sort-performance" },
    { key: "bundles", label: "Bundles", path: "/bundles" },
    { key: "projects", label: "Projects (new items, from the project app)", path: "/projects" },
    { key: "scrape", label: "Scrape", path: "/scrape" },
    { key: "coverage", label: "Celebrity Coverage", path: "/coverage" },
    { key: "celebrities", label: "Celebrities (cards + social accounts)", path: "/celebrities" },
];

// Extra rights the SRM can give an AM (off by default). Keys match AM_RIGHTS in backend/core/auth.py.
export const AM_RIGHTS = [
    {
        key: "team_limits",
        label: "See the whole team's exclusivity limits",
        help: "Exclusive Items shows every celebrity over / at the limit with their AM, so they can warn a colleague (counts only).",
    },
    {
        key: "upload_exclusivity",
        label: "Upload the exclusivity file",
        help: "The platform's exclusivity request export (Exclusive Items → Exclusivity periods).",
    },
];

// The What to add page holds four tabs; it shows while any one is on.
export const SUGGESTION_TABS = ["add", "prices", "new", "top"];

export const canSee = (user, key) => user?.role !== "AM" || !(user.hidden_tabs || []).includes(key);

export const canSeeAny = (user, keys) => keys.some((k) => canSee(user, k));

// Where a user lands: SRM dashboard, else the AM's first tab that's on.
export const homePath = (user) => {
    if (user?.role === "SRM") return "/dashboard/srm";
    if (user?.role === "SCM") return "/scm";
    if (canSeeAny(user, SUGGESTION_TABS)) return "/suggestions";
    const t = AM_TABS.find((x) => x.path && canSee(user, x.key));
    return t ? t.path : "/profile";
};
